import { Component, HostListener, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { RouterOutlet } from '@angular/router';
import { CommonModule } from '@angular/common';

import { AuthService } from './features/admin/auth/services/auth.service';
import { LoadingScreenComponent } from './shared/components/loading-screen/loading-screen.component';
import { LoadingService } from './core/services/loading.service';
import { SessionService } from './features/admin/user-management/services/session.service';
import { ThemeService } from './core/services/theme.service';
import { GlobalSearchComponent } from './shared/components/global-search/global-search.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [CommonModule, RouterOutlet, LoadingScreenComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {
  title = 'cris7ianback';

  constructor(
    private readonly sessionService: SessionService,
    public authService: AuthService,
    public readonly loadingService: LoadingService,
    public themeService: ThemeService,
    private dialog: MatDialog
  ) { }

  ngOnInit(): void {
    this.themeService.initializeTheme();

    if (this.authService.isAuthenticated()) {
      this.sessionService.startSessionTimer();
    }
  }

  @HostListener('window:keydown', ['$event'])
  handleKeyDown(event: KeyboardEvent) {
    if ((event.ctrlKey || event.metaKey) && event.key === 'k') {
      event.preventDefault();
      this.openSearch();
    }
  }

  openSearch() {
    this.dialog.open(GlobalSearchComponent, {
      width: '600px',
      position: { top: '15vh' },
      panelClass: 'global-search-dialog'
    });
  }

  // ============================================
  // 🔥 PULL TO REFRESH (Solo Móvil)
  // ============================================
  private touchStartY = 0;
  pullDistance = 0;
  isRefreshing = false;

  @HostListener('window:touchstart', ['$event'])
  onTouchStart(event: TouchEvent) {
    if (typeof window !== 'undefined' && window.innerWidth <= 768 && window.scrollY === 0) {
      this.touchStartY = event.touches[0].clientY;
      // Previene el rebote elástico nativo del navegador durante el drag
      if (typeof document !== 'undefined') {
        document.body.style.overscrollBehaviorY = 'none';
      }
    }
  }

  @HostListener('window:touchmove', ['$event'])
  onTouchMove(event: TouchEvent) {
    if (this.touchStartY > 0 && typeof window !== 'undefined' && window.innerWidth <= 768 && window.scrollY <= 0 && !this.isRefreshing) {
      const touchY = event.touches[0].clientY;
      const distance = touchY - this.touchStartY;
      if (distance > 0) {
        // Velocidad visual con fricción (0.4) y límite antes de trancar en 100px
        this.pullDistance = Math.min(distance * 0.4, 100);
      }
    }
  }

  @HostListener('window:touchend')
  onTouchEnd() {
    if (this.pullDistance > 60 && !this.isRefreshing) {
      this.isRefreshing = true;
      // Mostrar la recarga visual por corto tiempo y luego actualizar duro la web app
      setTimeout(() => {
        if (typeof window !== 'undefined') {
          window.location.reload();
        }
      }, 400); // Pequeña demora para que el usuario vea la animación girando
    } else {
      this.pullDistance = 0;
      this.touchStartY = 0;
      // Restaura el compartamiento nativo
      if (typeof document !== 'undefined') {
        document.body.style.overscrollBehaviorY = 'auto';
      }
    }
  }
}
